(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["saaz-size-fit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('saaz-size-fit')) {
    customElements.define('saaz-size-fit', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-fit-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-fit-panel]'));
        this.dialog = this.querySelector('dialog');
        this.measureTitle = this.querySelector('[data-measure-title]');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', event => {
            const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
            if (!keys.includes(event.key)) return;
            event.preventDefault();
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            this.selectTab(next);
            this.tabs[next].focus();
          });
        });
        this.querySelector('[data-measure-open]').addEventListener('click', () => {
          this.showStep(0);
          this.dialog.showModal();
        });
        this.querySelector('[data-measure-close]').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-measure-next]').addEventListener('click', () => this.showStep(1));
        this.querySelector('[data-measure-previous]').addEventListener('click', () => this.showStep(0));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
      }
      selectTab(index) {
        this.tabs.forEach((tab, current) => {
          tab.setAttribute('aria-selected', String(current === index));
          tab.tabIndex = current === index ? 0 : -1;
          this.panels[current].hidden = current !== index;
        });
      }
      showStep(index) {
        this.querySelectorAll('[data-measure-step]').forEach(step => { step.hidden = Number(step.dataset.measureStep) !== index; });
        this.querySelectorAll('[data-progress]').forEach(step => step.classList.toggle('is-active', Number(step.dataset.progress) === index));
        this.measureTitle.textContent = index === 0 ? this.measureTitle.dataset.firstTitle : this.measureTitle.dataset.secondTitle;
        this.querySelector('[data-measure-next]').hidden = index !== 0;
        this.querySelector('[data-measure-previous]').hidden = index !== 1;
        if (this.dialog.open) this.querySelector(index === 0 ? '[data-measure-next]' : '[data-measure-previous]').focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
